import { apiClient } from '@/services';

export const aiEvaluationResultsApi = {
  humanize: async (report) => {
    const response = await apiClient.post('/v1/ai-evaluation-results/humanize', report);
    return response?.data?.analysis;
  },
};